import styled from "styled-components";
import { FaFilePen, FaTrash, FaEnvelope, FaPlus, FaUsers } from 'react-icons/fa6';
import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { protectedResources } from 'config/msalConfig';
import DeleteConfirmationModal from "components/shared/DeleteConfirmationModal";
import { Badge, Button, Space, Table, Input } from "antd";
import qs from 'qs';
// import { DataEditor } from "./DataEditor";
// import OrgModuleData from "components/shared/OrganizationModules/OrgModuleData";
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { App, message } from 'antd';
// import NewOrganizationModal from './NewOrgModal';
import { DataEditor } from "./DataEditor";
// import RoleValueTable from "./RoleValueSubTable/RoleValueTable";
import ShareInvitationModal from "components/shared/ShareInvitationModal";

// import { NewOrganizationModal } from "./NewOrganizationModal";

import execute from "hooks/execute";


function formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');  // Adjust 'en-US' as needed for your locale
}

function OrgManagementTable({ userDetails, searchResults }) {    
    const [isDataEditorOpen, setIsDataEditorOpen] = useState(false);        
    const [editableDataItem, setEditableDataItem] = useState({});

    const navigate = useNavigate();
    const location = useLocation();


  const [isEditModalOpen, setIsEditModalOpen] = useState(false);


    const [modalIsOpen, setModalIsOpen] = useState(false);

    const toggleModal = () => {
        setIsDataEditorOpen(!isDataEditorOpen);
        setModalIsOpen(!modalIsOpen)
    };

    // const handleUserAdded = () => {
    //     setRefreshData(!refreshData); // Toggle refreshData to trigger data refetch
    //   };

    console.log("userDetails/////////////")
    console.log(userDetails)

    const [currentRecord, setCurrentRecord] = useState(null);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const { orgId } = useParams();
    const [customers, setCustomers] = useState(searchResults || []);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [inviteModalOpen, setInviteModalOpen] = useState(false);
    const [inviteInfo, setInviteInfo] = useState({ name: '', email: '', link: '' });
    const [invitedOrgId, setInvitedOrgId] = useState(null);

    const [tableParams, setTableParams] = useState({
        pagination: {
          current: 1,
          pageSize: 10,
        },
    });

    const hasNavigatedToHighlight = useRef(false);

    const openEditorToAdd = () => {
        console.log("openEditorToAdd");
        setEditableDataItem();
        setIsDataEditorOpen(true);
    };

    const openEditorToEdit = (record) => {
        console.log("edit", record);
        setEditableDataItem({ ...record, Org_ID: record.Org_ID });
        setIsDataEditorOpen(true);
    };

    //searchFilter
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
        <div
            style={{
            padding: 8,
            }}
            onKeyDown={(e) => e.stopPropagation()}
        >
            <Input
            ref={searchInput}
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{
                marginBottom: 8,
                display: 'block',
            }}
            />
            <Space>
            <Button
                type="primary"
                onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                icon={<SearchOutlined />}
                size="small"
                style={{
                width: 90,
                }}
            >
                Search
            </Button>
            <Button
                onClick={() => clearFilters && handleReset(clearFilters)}
                size="small"
                style={{
                width: 90,
                }}
            >
                Reset
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                confirm({
                    closeDropdown: false,
                });
                setSearchText(selectedKeys[0]);
                setSearchedColumn(dataIndex);
                }}
            >
                Filter
            </Button>
            <Button
                type="link"
                size="small"
                onClick={() => {
                close();
                }}
            >
                close
            </Button>
            </Space>
        </div>
        ),
        filterIcon: (filtered) => (
        <SearchOutlined
            style={{
            color: filtered ? '#1677ff' : undefined,
            }}
        />
        ),
        onFilter: (value, record) =>
        record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
        onOpenChange(open) {
            if (open) {
            setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        },
        render: (text) =>
        searchedColumn === dataIndex ? (
            <Highlighter
            highlightStyle={{
                backgroundColor: '#ffc069',
                padding: 0,
            }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ''}
            />
        ) : (
            text
        ),
    });

  //endSearchFilter

    const columns = [
        {
            title: 'Created On',
            dataIndex: 'CreatedOn',
            key: 'CreatedOn',
            sorter: true,
            render: (text) => formatDate(text),
        },
        {
            title: 'Organization Name',
            dataIndex: 'Org_Name',
            key: 'Org_Name',
            sorter: true,
            ...getColumnSearchProps('Org_Name'),
        },
        {
            title: 'Email',
            dataIndex: 'Org_Email',
            key: 'Org_Email',
            sorter: true,
            ...getColumnSearchProps('Org_Email'),
        },
        {
            title: 'Org Address',
            dataIndex: 'Org_Address',
            key: 'Org_Address',
            sorter: true,
            ...getColumnSearchProps('Org_Address'),

        },
        {
            title: 'Modules',
            dataIndex: 'Modules',
            key: 'Modules',
            sorter: true,
            ...getColumnSearchProps('Modules'),
           
        },
        {
            title: <Button color="default" variant="text" onClick={ openEditorToAdd } icon={<FaPlus  style={{ color: '#ffad1c' }} />} />,
            key: 'actions',
            render: (text, record) => (
                <>
                    <Button  color="default" variant="text"  title="Resend the invitation" onClick={(e) => {
                        e.stopPropagation();
                        handleSendInvitation( record, record.Org_ID );
                    }} icon={<FaEnvelope style={{ color: '#ffad1c' }} />} />
                                            
                    <Button   color="default" variant="text" onClick={(e) => {
                        console.log(record)
                        e.stopPropagation(); // Prevent row click
                        openEditorToEdit(record);
                        setCurrentRecord({ ...record, Org_ID: record.Org_ID });
                        // setIsEditModalOpen(true);
                    }} icon={<FaFilePen  style={{ color: '#ffad1c' }} />} />
                                        
                    <Button   color="default" variant="text" onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        handleDelete(record.Org_ID,record);
                    }} icon={<FaTrash style={{ color: '#ffad1c' }} />} />

                    <Button color="default" variant="text" onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/org-customers/${record.Org_ID}`);
                    }}icon={<FaUsers style={{ color: '#ffad1c' }} />} />
                </>
                
            ),
        },
    ];

    const handleSaveEditedUser = async updatedRecord => {
        await fetchData(); // Refetch data after deletion
        setIsEditModalOpen(false);
      };

    const handleDataEditFinished = (newData) => {
        console.log("handleDataEditFinished", newData, editableDataItem);
        setIsDataEditorOpen(false);
        fetchData();
    };

    const handleDataEditCancelled = () => {
        console.log("handleDataEditCancelled");
        setIsDataEditorOpen(false);
    };


    const getTableParams = (params) => ({
        pS: params.pagination?.pageSize,
        pN: params.pagination?.current,
        sF: params.sortField,
        sO: params.sortOrder,
        f: params.filters
        // ...params,
    });
  const { message, model, notification } = App.useApp();


    const handleSendInvitation = async (record, Org_ID) => {
        console.log('Send Invitation:', Org_ID, record);
        try {
        var response = await execute('POST', `${protectedResources.api.baseEndPoint}/organizations/sendSignupInvitationOrgUser`, {
            Org_ID: Org_ID,
            sendEmail: false
        });
        if(response.success){
          const data = response.data || {};
          setInviteInfo({
            name: data.customerName || record.Org_Name || '',
            email: data.email || record.Org_Email || '',
            link: data.inviteLink || ''
          });
          setInvitedOrgId(Org_ID);
          setInviteModalOpen(true);
        }else{
          message.error(response.message || 'Failed to send invitation');
        }
        }catch(error){
          message.error('Failed to send invitation: ' + error.message);
        }
    };

    const handleCopyInvite = async () => {
        try { await navigator.clipboard.writeText(inviteInfo.link || ''); } catch (_) {}
    };

    const handleResendEmail = async () => {
        const response = await execute('POST', `${protectedResources.api.baseEndPoint}/organizations/sendSignupInvitationOrgUser`, { Org_ID: invitedOrgId, inviteLink: inviteInfo.link, sendEmail: true });
        if (!response.success) {
            throw new Error(response.message || 'Failed to send invitation');
        }
        return true;
    };

    const handleDelete = (Org_ID, record) => {
        console.log(Org_ID, record)
        setCurrentRecord({ ...record, Org_ID: Org_ID });
        setDeleteModalOpen(true);
      };

    const handleConfirmDelete = async () => {
        console.log(currentRecord)
        // return;
        try {
            const response = await execute("DELETE", `${protectedResources.api.baseEndPoint}/organizations`, {
                orgId: currentRecord.Org_ID});
            if (response.success) {
                alert('User deleted successfully.');
                await fetchData(); // Refetch data after deletion
            } else {
                setError(response.message || 'Failed to delete user');
            }
        } catch (error) {
            alert('Failed to delete user: ' + error.message);
        }
        setDeleteModalOpen(false);
    };

    const fetchData = async (params = tableParams) => {
        console.log("fetchData")
        try {
            setLoading(true);
            console.log(getTableParams(params))
            const response = await execute("GET", `${protectedResources.api.baseEndPoint}/organizations?${qs.stringify(getTableParams(params))}`);

            console.log(response)

            if (response.success && response.data.length > 0) {
                console.log("customerData///////////")
                console.log(response.data)
                setCustomers(response.data);
                setTableParams((prev) => {
                    const nextTotal = Number(response.totalRecords || 0);
                    if (prev?.pagination?.total === nextTotal) {
                        return prev;
                    }
                    return {
                        ...prev,
                        pagination: {
                            ...prev.pagination,
                            total: nextTotal,
                        },
                    };
                });
                setError('');
            } else {
                setCustomers([]);
                setTableParams((prev) => ({
                    ...prev,
                    pagination: {
                        ...prev.pagination,
                        total: 0,
                    },
                }));
                setError(response.message || 'No customers found for the specified organization');
            }
            
            setLoading(false);
        } catch (err) {
            console.log(err)
            setError('Failed to fetch data: ' + err.message);
            setLoading(false);
        }
    };
    // Fetch all organizations to find the highlighted one's page
    const findOrganizationPage = async (orgId) => {
        try {
            // Fetch all organizations without pagination to find the target
            const allOrgsParams = {
                pS: 1000, // Large page size to get all orgs
                pN: 1,
                sF: tableParams?.sortField,
                sO: tableParams?.sortOrder,
                f: tableParams?.filters
            };
            const response = await execute("GET", `${protectedResources.api.baseEndPoint}/organizations?${qs.stringify(allOrgsParams)}`);
            if (response.success && response.data.length > 0) {
                const orgIndex = response.data.findIndex(org => org.Org_ID === orgId);
                if (orgIndex !== -1) {
                    const pageSize = tableParams.pagination.pageSize;
                    const targetPage = Math.floor(orgIndex / pageSize) + 1;
                    return targetPage;
                }
            }
            return null;
        } catch (err) {
            console.error('Error finding organization page:', err);
            return null;
        }
    };
    useEffect(() => {
        console.log(orgId)
        console.log(userDetails)
        fetchData(tableParams);
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        tableParams?.sortOrder,
        tableParams?.sortField,
        // searchText
        tableParams?.filters,
    ]);

    useEffect(() => {
        if (searchResults) {
            setCustomers(searchResults);
        }
    }, [searchResults]);

    // Auto-navigate to the page containing the highlighted organization
    useEffect(() => {
        const navigateToHighlightedOrg = async () => {
            if (location.state?.highlightOrgId && !loading && !hasNavigatedToHighlight.current) {
                console.log('Finding page for highlighted org:', location.state.highlightOrgId);
                hasNavigatedToHighlight.current = true;
                const targetPage = await findOrganizationPage(location.state.highlightOrgId);
                console.log('Target page found:', targetPage);
                if (targetPage) {
                    setTableParams((prev) => {
                        if (prev.pagination.current === targetPage) {
                            return prev;
                        }
                        return {
                            ...prev,
                            pagination: {
                                ...prev.pagination,
                                current: targetPage
                            }
                        };
                    });
                }
            }
        };
        navigateToHighlightedOrg();
    }, [location.state?.highlightOrgId, loading]);
    // Reset navigation flag when highlightOrgId changes
    useEffect(() => {
        hasNavigatedToHighlight.current = false;
    }, [location.state?.highlightOrgId]);

    const handleTableChange = (pagination, filters, sorter) => {
        console.log("filters change")
        console.log(filters)
        console.log('handleTableChange', pagination, filters, sorter);

        // Filter out null or empty values
        const cleanedFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value && value.length > 0)
        );

        console.log(cleanedFilters)

        setTableParams((prev) => ({
            ...prev,
            pagination: {
                ...prev.pagination,
                ...pagination,
            },
            filters: cleanedFilters,
            sortOrder: Array.isArray(sorter) ? undefined : sorter.order,
            sortField: Array.isArray(sorter) ? undefined : sorter.field,
        }));
    
        // `dataSource` is useless since `pageSize` changed
        if (pagination.pageSize !== tableParams.pagination?.pageSize) {
          setCustomers([]);
        }
    };

    

    const handleCloseModalEdit = () => {
        setIsEditModalOpen(false);
      };

    // const expandedRowRender = (record) => (
    //     <RoleValueTable customer={record} />
    // );

    return (
        <>
        <style>
            {`
                /* Highlight searched organization row */
                .highlighted-org-row {
                    background-color: #fff7e6 !important;
                    border-left: 3px solid #ffad1c !important;
                }
                .highlighted-org-row:hover {
                    background-color: #ffe7ba !important;
                }
            `}
        </style>
        <DataContainer>
            <Table
                scroll={
                    { x: 100 }
                }
                columns={columns}
                rowKey={record => record.Org_ID}
                dataSource={customers}
                pagination={tableParams.pagination}
                loading={loading}
                // expandable={{
                //     expandedRowRender,
                //     defaultExpandedRowKeys: ['0'],
                // }}
                onChange={handleTableChange}
                rowClassName={(record) =>
                    location.state?.highlightOrgId && record.Org_ID === location.state.highlightOrgId
                        ? 'highlighted-org-row'
                        : ''
                }
            />     
            
            { isDataEditorOpen ? 
                <DataEditor 
                    isOpen={isDataEditorOpen} 
                    dataItem={editableDataItem} 
                    onDataEditorFinished={handleDataEditFinished} 
                    onDataEditorCancelled={handleDataEditCancelled} /> 
                    : null }

               
                
            {isDeleteModalOpen && <DeleteConfirmationModal isOpen={isDeleteModalOpen} onClose={() => setDeleteModalOpen(false)} record={currentRecord} onDeleteConfirmed={handleConfirmDelete} />}
            {inviteModalOpen && (
                <ShareInvitationModal
                    isOpen={inviteModalOpen}
                    name={inviteInfo.name}
                    email={inviteInfo.email}
                    inviteLink={inviteInfo.link}
                    onCopyLink={handleCopyInvite}
                    onSendEmail={handleResendEmail}
                    onClose={() => setInviteModalOpen(false)}
                />
            )}
            </DataContainer>
        </>
    );
}

const DataContainer = styled.div`
  height:100%; /* Set your desired height */
  width:100%;
  overflow-x: auto;
`;



export default OrgManagementTable;
